export const Users = [
    {
      id:1,
      profilePicture: "assets/person/1.jpeg",
      username: "Manasa Ramkumar",
    },
    {
      id:2,
      profilePicture: "assets/person/2.jpeg",
      username: "Avinash Vijayakumar",
    },
    {
      id:3,
      profilePicture: "assets/person/3.jpeg",
      username: "Surya charan",
    },
    {
      id:4,
      profilePicture: "assets/person/4.jpeg",
      username: "Monisha raghu",
    },
    {
      id:5,
      profilePicture: "assets/person/5.jpeg",
      username: "Jeya prajesh",
    },
    {
      id:6,
      profilePicture: "assets/person/6.jpeg",
      username: "Ramya",
    },
    {
      id:7,
      profilePicture: "assets/person/7.jpeg",
      username: "Vidya Bharathi",
    },
    {
      id:8,
      profilePicture: "assets/person/8.jpeg",
      username: "Nishanthi",
    },
    {
      id:9,
      profilePicture: "assets/person/9.jpeg",
      username: "Sahana",
    },
    {
      id:10,
      profilePicture: "assets/person/10.jpeg",
      username: "Dhanya sriram",
    },
  ];
  
  export const Posts = [
    {
      id: 1,
      desc: "Love For All, Hatred For None.",
      photo: "assets/post/1.jpg",
      date: "5 mins ago",
      userId: 1,
      like: 32,
      comment: 9,
    },
    {
      id: 2,
      photo: "assets/post/2.jpg",
      date: "15 mins ago",
      userId: 2,
      like: 2,
      comment: 1,
    },
    {
      id: 3,
      desc: "Every moment is a fresh beginning.",
      photo: "assets/post/3.jpg",
      date: "1 hour ago",
      userId: 3,
      like: 61,
      comment: 2,
    },
    {
      id: 4,
      photo: "assets/post/4.jpg",
      date: "4 hours ago",
      userId: 4,
      like: 7,
      comment: 3,
    },
    {
      id: 5,
      photo: "assets/post/5.jpg",
      date: "5 hours ago",
      userId: 5,
      like: 23,
      comment: 5,
    },
    {
      id: 6,
      photo: "assets/post/6.jpg",
      date: "1 day ago",
      userId: 6,
      like: 44,
      comment: 6,
    },
    {
      id: 7,
      desc: "Never regret anything that made you smile.",
      photo: "assets/post/7.jpg",
      date: "2 days ago",
      userId: 7,
      like: 52,
      comment: 3,
    },
    {
      id: 8,
      photo: "assets/post/8.jpg",
      date: "3 days ago",
      userId: 8,
      like: 15,
      comment: 1,
    },
    {
      id: 9,
      desc: "Change the world by being yourself.",
      photo: "assets/post/9.jpg",
      date: "5 days ago",
      userId: 9,
      like: 11,
      comment: 2,
    },
    {
      id: 10,
      photo: "assets/post/10.jpeg",
      date: "1 week ago",
      userId: 10,
      like: 104,
      comment: 12,
    },
  ];